import * as CameraParticipantActionTypes from "./actionTypes";
export const addCameraParticipantRequest = (deviceId) => {
    return {
        type: CameraParticipantActionTypes.ADD_CAMERA_PARTICIPANT_REQUEST,
        payload: {
            deviceId,
        }
    };
};
export const addCameraParticipantSuccess = (deviceId, conference, connection) => {
    return {
        type: CameraParticipantActionTypes.ADD_CAMERA_PARTICIPANT_SUCCESS,
        payload: {
            deviceId,
            conference,
            connection,
        }
    };
};
export const addCameraParticipantFailure = (deviceId, error) => {
    return {
        type: CameraParticipantActionTypes.ADD_CAMERA_PARTICIPANT_FAILURE,
        payload: {
            deviceId,
            error,
        }
    };
};
export const removeCameraParticipantRequest = (deviceId) => {
    return {
        type: CameraParticipantActionTypes.REMOVE_CAMERA_PARTICIPANT_REQUEST,
        payload: {
            deviceId
        }
    };
};
export const removeCameraParticipantSuccess = (deviceId) => {
    return {
        type: CameraParticipantActionTypes.REMOVE_CAMERA_PARTICIPANT_SUCCESS,
        payload: {
            deviceId
        }
    };
};
export const removeCameraParticipantFailure = (deviceId, error) => {
    return {
        type: CameraParticipantActionTypes.REMOVE_CAMERA_PARTICIPANT_FAILURE,
        payload: {
            deviceId,
            error
        }
    };
};
